import React from "react";
import Navbar from "components/Navbar";
import Footer from "components/Footer";
import Members from "components/AboutUs/Members";
import { useSelector } from 'react-redux';
import MobileNavbar from "components/MobileNavbar";
import MobileFooter from "components/MobileFooter";
import { useEffect } from "react";

function AboutUs () {
    const isMobile = useSelector(state=> state.windowSize.isMobile);
    
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, []);
    
    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbar />
            <Members />
            <MobileFooter />
            </>
        ) : (
            <>
            <Navbar />
            <Members />
            <Footer />
            </>
        )}
        </>
    )
};

export default AboutUs